import { Buffer } from 'buffer';

export const decodeBase64 = (encodedText: string) => {
	try {
		const decodedText = Buffer.from(encodedText, 'base64').toString('utf-8');
		console.log('dec', decodedText);
		return decodedText;
	} catch (error) {
		console.log('Here', error);
		return null;
	}
};

export const getCapitalCase = (text: string | null | undefined) => {
	if (!text) return text;
	try {
		return text
			.trimStart()
			.toLowerCase()
			.replace(/(^|\s)\S/g, (match) => match.toUpperCase());
	} catch (error) {
		/* empty */
	}
	return text;
};

export const addPeriod = (text: string | null | undefined) => {
	try {
		if (!text || !text.trim() || text.trim().endsWith('.')) return text;
		return text.trim() + '.';
	} catch (error) {
		/* empty */
	}
	return text;
};

export const getCapitalCaseAll = (text: string | null | undefined) => {
	try {
		text = text?.toUpperCase();
	} catch (error) {
		/* empty */
	}
	return text;
};

export const getNumberOfNightsBetweenDates = (
	arrivalDate: Date,
	departureDate: Date
) => {
	if (!arrivalDate || !departureDate) {
		return undefined;
	}
	const diff = departureDate.getTime() - arrivalDate.getTime();
	return Math.ceil(diff / (1000 * 3600 * 24));
};
export const isMobileDevice = (): boolean => {
	if (typeof window === 'undefined') return false;
	const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	const isSmallScreen = window.innerWidth <= 768;
	return isTouch && isSmallScreen;
};

const hexToRgb = (hex: string): string | null => {
	const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
	if (!match) return null;
	let value = match[1];
	if (value.length === 3) {
		value = value
			.split('')
			.map((c) => c + c)
			.join('');
	}
	const num = parseInt(value, 16);
	return `${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}`;
};

const isUrlValue = (value: string) =>
	/^https?:\/\//i.test(value) || value.startsWith('/');

/*
 * Overrides the :root CSS variables from theme-det.css with the property
 * branding returned by GetUIPropertiesByProperty — an array of
 * { uiKey, uiValue } pairs where uiKey is already a kebab-case variable
 * name (e.g. "primary-color"). The override is injected as a stylesheet,
 * so it wins over the static theme CSS.
 */
export const applyUiProperties = (uiProperties: any[] | null) => {
	if (
		!uiProperties ||
		!Array.isArray(uiProperties) ||
		typeof document === 'undefined'
	) {
		return;
	}

	const rules: string[] = [];
	let primaryColor = '';

	uiProperties.forEach((item) => {
		if (!item || typeof item !== 'object') return;

		const key = item.uiKey;
		const value = item.uiValue;
		if (!key || value === null || value === undefined || value === '') return;

		let cssValue = String(value);
		if (typeof value === 'string' && isUrlValue(value)) {
			cssValue = `url("${value}")`;
		}

		if (key === 'primary-color') primaryColor = String(value);

		rules.push(`--${key}: ${cssValue};`);
	});

	if (primaryColor) {
		const rgb = hexToRgb(primaryColor);
		if (rgb) rules.push(`--primary-color-rgb: ${rgb};`);
	}

	if (!rules.length) return;

	const styleTagId = 'ui-properties-override';
	let styleTag = document.getElementById(styleTagId) as HTMLStyleElement | null;

	if (!styleTag) {
		styleTag = document.createElement('style');
		styleTag.id = styleTagId;
		document.head.appendChild(styleTag);
	}

	styleTag.textContent = `:root {\n  ${rules.join('\n  ')}\n}`;
};
